<template>
  <div class="vcom-consent-page-template">
    <div class="consent-wrapper">
      <span>
        Dear
        <b>Osteopathic Medical Student</b>:
        <br />
        <br />You are invited to complete a series of brief surveys as part of aresearch project conducted by VCOM researchers:
        Natalie M.Fadel, PsyD, Alexis M. Stoner, PhD, MPH, Lindsey M. Ridgeway, PhD, MEd, Harold Garner, PhD, and Ning Cheng, PhD;
        and the Co-Founders and COOs of Resiliency Technologies: Tim Farrell and Robyn Hussa Farrell.
        The research team was awarded grant funding to develop content for this app specific to the needs of VCOM students.
        <br />
        <br />Participation in the study includes completion of a brief survey upon initial log in, a survey six months later and a last survey after one year of usage.
        The survey takes approximately 10 minutes to complete, and asks about your current resiliency levels, connectedness to mental health and wellness services,
        and thoughts on the VCOM mental health and wellness app. Those who consent to participate in the study will be entered into a drawing for a $25 Amazon gift card,
        of which 3 total gift cards will be offered. This survey is voluntary. All students are free to decline participation and
        this choice will not impact any academics or opportunities to use the app.
        <br />
        <br />By completing this survey, you affirm that you are at least 18 years old and are aware that your responses may be used for research purposes.
        Your responses will remain confidential, as your data will be de-identified.
        By submitting your responses,you give your consent for the research team to use your survey answers
        and for the research team to use your usability data from your app usage in analysis for the study and publication of the results.
        If you have any questions about this survey before or after you complete the survey,
        please contact Natalie Fadel,
        <a
          href="mailto:nfadel@carolinas.vcom.edu"
        >nfadel@carolinas.vcom.edu</a>.
        If you have any concerns or questions about your rights as a future participant in research, please contact the Chairman of the VCOM Institutional Review Board,
        Dr. Brolinson at
        <a
          href="mailto:pbrolins@vcom.vt.edu"
        >pbrolins@vcom.vt.edu</a>.
      </span>
    </div>
    <div class="input-wrapper" style="justify-content: center;">
      <Button @click="proceed(false)" style="margin-top: 10px;" size="large" type="text">Disagree</Button>
      <Button @click="proceed(true)" style="margin-top: 10px;" size="large" type="primary">Agree</Button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VCOMConsentPage",
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"])
  },
  methods: {
    ...mapActions("user", ["saveBrandConsent"]),
    async proceed(isAgree) {
      try {
        await this.saveBrandConsent({
          user_agree: isAgree,
          email: this.userInfo.email[0].email,
          brand_id: this.brandInfo.id
        })
      }
      catch(error){
        console.log("Unable to save consent data", error)
      }
      finally {
        this.nextPage(isAgree)
      }
    },
    nextPage(isAgree) {
      this.$emit("nextPage", isAgree ? undefined : "skipIframeSurvey");
    }
  }
};
</script>

<style lang="scss" scoped>
.vcom-consent-page-template {
  height: 100%;
  display: flex;
  flex-direction: column;
  .consent-wrapper {
    height: 75vh;
    overflow-y: auto;
  }
}
</style>